import { config } from '@services/config';
import { SubjectivitySearchRequestQuery, SubjectivitySearchResponse } from '@lio/api-types';
import { subjectivityQueryKeys } from '@services/subjectivity/keys';
import { getSubjectivitiesQuery } from '@services/subjectivity/subjectivity.helpers';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchSubjectivities = (queryParams: SubjectivitySearchRequestQuery) => {
  const client = useClient();
  const query = getSubjectivitiesQuery(queryParams);

  const result = useQuery({
    queryKey: subjectivityQueryKeys.searchWithParams(queryParams),
    queryFn: () => client.get(`subjectivity?${query}`).json<SubjectivitySearchResponse>(),
    ...config,
    enabled: !!queryParams?.policyId || !!queryParams?.quoteId,
  });

  return { ...result, subjectivities: result.data };
};
